import type { Context } from 'react';
import { useContext } from 'react';

export function useDefinedContext<T>(context: Context<T | null>): T {
    const expectedContext = useContext(context);

    if (!expectedContext) {
        throw new Error('Expected to find context');
    }

    return expectedContext;
}
